import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const ChatLoader = () => {
  return (
    <div>
      <div className=" p-4">
        <div
          style={{
            maxWidth: '350px',
            marginLeft: 'auto',
          }}
        >
          <Skeleton variant="rounded" height={50} />
        </div>
        <div
          className="my-5"
          style={{
            maxWidth: '350px',
            marginRight: 'auto',
          }}
        >
          <Skeleton variant="rounded" height={50} />
        </div>
        <div
          style={{
            maxWidth: '350px',
            marginLeft: 'auto',
          }}
        >
          <Skeleton variant="rounded" height={50} />
        </div>
        <div
          className="my-5"
          style={{
            maxWidth: '350px',
            marginRight: 'auto',
          }}
        >
          <Skeleton variant="rounded" height={50} />
        </div>
        <div
          style={{
            maxWidth: '350px',
            marginLeft: 'auto',
          }}
        >
          <Skeleton variant="rounded" height={50} />
        </div>
      </div>
    </div>
  );
};

export default ChatLoader;
